module.exports = __webpack_public_path__ + "img/yanke.d9cc101.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yanke.png
// module id = U6zM
// module chunks = 0